

export const FetchAdminLogin = async (data) => {
  const API_URL = process.env.REACT_APP_API_URL + "auth/admin/login";
  try {
    const response = await fetch(API_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(data)
    });

    if (response.status === 200) {
      const resData = await response.json();
      console.log(resData )
      localStorage.setItem("token", resData.token);
      localStorage.setItem("role", resData.role)
      return true;
    } else {
      console.warn("Access token is missing in response");
      return false;
    }
  } catch (error) {
    console.error("FetchAdminLogin error:", error);
    return false;
  }
};


export const deleteAdminApi = async (id) => {
  const token=localStorage.getItem("token")
  const API_URL = process.env.REACT_APP_API_URL + "auth/admin/delete-admin/";
  try {
    const response = await fetch(API_URL + id, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      }
    });

    return {
      status: response.status
    };
  } catch (error) {
    console.error("[deletePackeges] Error deleting package:", error);
    return {
      status: 500
    };
  }
};

export const FetchAdminForgotPassword = async (data) => {
  const API_URL = process.env.REACT_APP_API_URL + "auth/admin/forgot-password";
  try {
    const response = await fetch(API_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(data)
    });

    if (response.status === 200) {
      const data = await response.json();
      return true;
    } else {
      return false;
    }
  } catch (error) {
    console.error("FetchAdminLogin error:", error);
    return false;
  }
};